import { createFileRoute } from "@tanstack/react-router";
import {
  CollectionPage,
  CollectionErrorComponent,
  CollectionNotFoundComponent,
} from "@/pages/CollectionPage";
import { allProductsLoader, allProductsHeadDa } from "@/pages/AllProductsPage";

export const Route = createFileRoute("/alle")({
  loader: allProductsLoader,
  head: allProductsHeadDa,
  component: CollectionPage,
  errorComponent: CollectionErrorComponent,
  notFoundComponent: CollectionNotFoundComponent,
});
